"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateHaulerToSTransport = exports.HaulerToSTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.HaulerToSTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    termsOfService: typebox_1.Type.Optional(typebox_1.Type.String()),
    termsOfServiceUrl: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.UpdateHaulerToSTransport = typebox_1.Type.Object({
    termsOfService: typebox_1.Type.Optional(typebox_1.Type.String()),
    termsOfServiceUrl: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=hauler-terms-of-service-transport.js.map